import { render, staticRenderFns } from "./DealTheme.vue?vue&type=template&id=1516e67f&scoped=true&lang=pug&"
import script from "./DealTheme.vue?vue&type=script&lang=js&"
export * from "./DealTheme.vue?vue&type=script&lang=js&"
import style0 from "./DealTheme.vue?vue&type=style&index=0&id=1516e67f&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1516e67f",
  null
  
)

export default component.exports